import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "../Header/AppHeader.jsx";
import AppFooter from "../UI/Footer/AppFooter.jsx";
import MobileBottomNav from "../Layout/MobileBottomNav.jsx";

export default function AppLayout() {
  return (
    <>
      <AppHeader />
      <Outlet />
      <AppFooter />
      <MobileBottomNav />
    </>
  );
}

